export default __webpack_public_path__ + "static/media/videos.028f5eb9.jpg";